import { GlobalConfigType } from 'actions/global.config.type'
import { SET_GLOBAL_CONFIG } from 'actions/types'

import { createReducer } from '../utils'

const getInitialState = (): Record<GlobalConfigType, any> => {
  return {
    [GlobalConfigType.LoanStatus]: {},
    [GlobalConfigType.LoanFields]: {},
    [GlobalConfigType.PagePermissions]: {},
    [GlobalConfigType.Footer]: {},
    [GlobalConfigType.ConditionTypes]: [],
    [GlobalConfigType.DocumentCategory]: [],
    [GlobalConfigType.GlobalSettingV2]: {},
    [GlobalConfigType.LoanSubmissionHierarchy]: [],
    [GlobalConfigType.GUARANTER_CONFIG]: {},
    [GlobalConfigType.ORDER_VALUATION]: {},
    [GlobalConfigType.ACCOUNT_TYPES]: {},
    [GlobalConfigType.PARTIES]: {},
    [GlobalConfigType.EMAIL_OPTIONS]: {},
    [GlobalConfigType.GTM]: {},
    [GlobalConfigType.RulesConfig]: {},
    [GlobalConfigType.IneligibleParties]: {},
    [GlobalConfigType.SecondaryMarketing]: {},
    [GlobalConfigType.PAYMENT_CODE]: [],
    [GlobalConfigType.PAYMENT_METHOD]: [],
    [GlobalConfigType.ACCOUNT_PAYEES]: [],
    [GlobalConfigType.ACCOUNT_SECTIONS]: [],
    [GlobalConfigType.ACCOUNTING_ACCOUNT_TYPES]: [],
    [GlobalConfigType.EmailModalDefaults]: {},
    [GlobalConfigType.DefaultSenderEmailByAccountType]: [],
    [GlobalConfigType.ReportPlaceholders]: {},
    [GlobalConfigType.LoanSubStatus]: {},
    [GlobalConfigType.ShippingInfoHeaders]: [],
    [GlobalConfigType.UWConditionCategories]: [],
    [GlobalConfigType.LoanOverviewAccess]: {},
    [GlobalConfigType.HostWhiteLabel]: null,
  }
}

export const globalConfigReducer = createReducer(getInitialState(), {
  [SET_GLOBAL_CONFIG]: (state: any, { payload }: { payload: { type: GlobalConfigType; value: any } }) => {
    return {
      ...state,
      [payload.type]: payload.value,
    }
  },
})
